import { render, staticRenderFns } from "./StreamConfig.vue?vue&type=template&id=2a8de9d4&scoped=true&"
import script from "./StreamConfig.vue?vue&type=script&lang=js&"
export * from "./StreamConfig.vue?vue&type=script&lang=js&"
import style0 from "./StreamConfig.vue?vue&type=style&index=0&id=2a8de9d4&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a8de9d4",
  null
  
)

export default component.exports